<template>
    <div v-show="state.showModel == 'list'">
        <div class="table-page-search-wrapper">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="8" :sm="24">
                        <a-form-item label="标题">
                            <a-input v-model:value="queryParam.title" placeholder="请输入标题"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="8" :sm="24">
                        <span class="table-page-search-submitButtons">
                            <a-button type="primary" @click="loadData">查询</a-button>
                            <a-button style="margin-left: 8px" @click="refreshTabel">重置</a-button>
                            <a-button type="primary" style="margin-left: 8px" @click="showAddModal">
                                <PlusOutlined /> 新增
                            </a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
            @change="onChange">
            <template #bodyCell="{ column, record, index, text }">
                <template v-if="column.dataIndex === 'title'">
                    <a @click="handleInfo(record)">
                        {{ record.title }}
                    </a>
                </template>
                <template v-else-if="column.dataIndex == 'is_read'">
                    <a-tag color="green" v-if="record.is_read > 0">已读</a-tag>
                    <a-tag color="red" v-else>未读</a-tag>
                </template>
                <template v-else-if="column.dataIndex === 'action'">
                    <a-space>
                        <a @click="handleEdit(record)">编辑</a>
                        <a-divider type="vertical" />
                        <a-popconfirm title="确定要删除吗？" @confirm="handleDelete(record)">
                            <a style="color: red;">删除</a>
                        </a-popconfirm>
                    </a-space>
                </template>
            </template>
        </a-table>
    </div>
    <div v-show="state.showModel == 'info'" class="detail-wrapper">
        <!-- 详情内容 -->
        <div class="detail-container">
            <div class="detail-card">
                <!-- 返回按钮 -->
                <div class="detail-back">
                    <a-button type="link" @click="backToList" class="back-btn">
                        <RollbackOutlined /> 返回列表
                    </a-button>
                </div>

                <!-- 文章标题 -->
                <h1 class="detail-title">{{ state.detailData.title }}</h1>

                <!-- 文章元信息 -->
                <div class="detail-meta">
                    <div class="meta-item">
                        <CalendarOutlined style="margin-right: 6px; color: #1677ff;" />
                        <span>发布时间：{{ state.detailData.created_at }}</span>
                    </div>
                    <div class="meta-divider"></div>
                    <div class="meta-item">
                        <EyeOutlined style="margin-right: 6px; color: #1677ff;" />
                        <span>阅读量：{{ state.detailData.read_count || 0 }}</span>
                    </div>
                    <div class="meta-divider"></div>
                    <div class="meta-item">
                        <TagOutlined style="margin-right: 6px; color: #1677ff;" />
                        <span>分类：{{ state.detailData.cat_name || '未分类' }}</span>
                    </div>
                </div>

                <!-- 分割线 -->
                <div class="detail-divider"></div>

                <!-- 文章正文 -->
                <div class="detail-body" v-html="state.detailData.body" @click="handleImageClick">
                </div>

                <!-- 底部信息 -->
                <div class="detail-footer">
                    <div class="footer-left">
                        <a-tag color="blue" v-if="state.detailData.is_read > 0">
                            <CheckCircleOutlined /> 已读
                        </a-tag>
                        <a-tag color="red" v-else>
                            <ClockCircleOutlined /> 未读
                        </a-tag>
                    </div>
                    <div class="footer-right">
                        <span class="footer-time">更新于：{{ state.detailData.updated_at || state.detailData.created_at
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <a-modal v-model:open="state.modalVisible" :title="state.modalType === 'add' ? '新增消息' : '编辑消息'" @ok="handleModalOk"
        @cancel="handleModalCancel" :confirm-loading="state.modalLoading" width="800px">
        <a-form ref="formRef" :model="formData" :rules="formRules" layout="vertical">
            <a-form-item label="标题" name="title">
                <a-input v-model:value="formData.title" placeholder="请输入标题" maxlength="100" show-count />
            </a-form-item>
            <a-form-item label="内容" name="body">
                <a-textarea v-model:value="formData.body" placeholder="请输入内容" :rows="8" maxlength="5000" show-count />
            </a-form-item>
            <a-form-item label="分类" name="cat_id">
                <a-select v-model:value="formData.cat_id" placeholder="请选择分类">
                    <a-select-option v-for="item in state.menusList" :key="item.id" :value="item.id">
                        {{ item.cat_name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
        </a-form>
    </a-modal>

    <a-image :width="200" :style="{ display: 'none' }" :preview="{
        visible: state.previewVisible,
        onVisibleChange: setVisible
    }" :src="state.previewImage" />
</template>

<script lang="ts" setup>
import { PlusOutlined, RollbackOutlined, CalendarOutlined, EyeOutlined, TagOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons-vue'
import type { PaginationProps } from 'ant-design-vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { ref, reactive, onMounted, h, watch } from 'vue'
import NewsInfo from './NewsInfo.vue'
const emit = defineEmits(['showzw', 'backToList'])
const props = defineProps({
    catid: {
        type: Number,
        default: 0
    }
})
const columns = [
    {
        title: '标题',
        dataIndex: 'title'
    },
    {
        title: '阅读状态',
        dataIndex: 'is_read',
        width: '100px'
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        width: '120px'
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: '150px',
        fixed: 'right'
    }
]
interface data {
    showInfo: boolean
    detailData: any
    loading: boolean
    showModel: string
    previewImage: string
    previewVisible: boolean
    modalVisible: boolean
    modalLoading: boolean
    modalType: 'add' | 'edit'
    menusList: any[]
}
const state = reactive<data>({
    showInfo: false,
    detailData: {},
    loading: false,
    showModel: 'list',
    previewImage: '',
    previewVisible: false,
    modalVisible: false,
    modalLoading: false,
    modalType: 'add',
    menusList: []
})
interface queryParam {
    title?: string
}
let param = ref<queryParam>({ title: '' })
let queryParam = param.value
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '30', '40'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})

const formRef = ref()
const formData = reactive({
    id: 0,
    title: '',
    body: '',
    cat_id: 0
})

const formRules = {
    title: [
        { required: true, message: '请输入标题', trigger: 'blur' },
        { min: 2, max: 100, message: '标题长度在2-100个字符之间', trigger: 'blur' }
    ],
    body: [
        { required: true, message: '请输入内容', trigger: 'blur' },
        { min: 10, message: '内容至少10个字', trigger: 'blur' }
    ],
    cat_id: [
        { required: true, message: '请选择分类', trigger: 'change' }
    ]
}

onMounted(() => {
    state.showModel = 'list'
    loadData()
    loadCatList()
})

// 加载分类列表
const loadCatList = () => {
    let requestParam = {
        url: '/admin/v1/news/headCatList',
        method: 'post',
        data: {}
    }
    baseService(requestParam).then((res: any) => {
        state.menusList = res.data || []
    })
}

watch(
    () => props.catid,
    (val) => {
        //改变分类，重置表单重新加载数据
        state.showModel = 'list'
        refreshTabel()
    }
)
const refreshTabel = () => {
    pagination.current = 1
    param.value = {}
    queryParam = param.value
    loadData()
}
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/newsMyList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, cat_id: props.catid }, queryParam)
    }
    baseService(requestParam)
        .then((res) => {
            state.loading = false
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item) => ({ ...item, isShowOptions: false }))
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取列表失败')
            }
        })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const handleInfo = (record) => {
    state.showInfo = true
    state.showModel = 'info'
    state.detailData = { ...record }
    // 如果后端没有返回阅读量，可以默认为0
    if (!state.detailData.read_count) {
        state.detailData.read_count = 0
    }
    //处理一下图片，正则去掉img标签的style
    state.detailData.body = state.detailData.body.replace(/<img[^>]*>/gi, (imgTag) => {
        // 检查是否是SVG图片
        if (imgTag.includes('.svg') || imgTag.includes('.svg?')) {
            return imgTag // 如果是SVG，保持原样不处理
        }

        // 非SVG图片：去掉style属性并添加新样式
        const cleanTag = imgTag.replace(/\s*style\s*=\s*["'][^"']*["']/gi, '')
        return cleanTag.replace('<img', '<img style="max-width:100%;height:auto;border-radius:8px;margin:10px 0;box-shadow:0 2px 8px rgba(0,0,0,0.1);"')
    })
    //查询一下详情，让其变成已读
    queryDetail(record.id)
    emit('showzw', true)
}

// 返回列表方法
const backToList = () => {
    state.showModel = 'list'
    state.showInfo = false
    state.detailData = {}
    emit('backToList')
    loadData()
}

// 显示新增弹窗
const showAddModal = () => {
    state.modalType = 'add'
    state.modalVisible = true
    formData.id = 0
    formData.title = ''
    formData.body = ''
    formData.cat_id = props.catid || 0
    setTimeout(() => {
        formRef.value?.resetFields()
    }, 100)
}

// 显示编辑弹窗
const handleEdit = (record) => {
    state.modalType = 'edit'
    state.modalVisible = true
    formData.id = record.id
    formData.title = record.title
    formData.body = record.body || ''
    formData.cat_id = record.cat_id || props.catid || 0
    setTimeout(() => {
        formRef.value?.resetFields()
    }, 100)
}

// 删除
const handleDelete = (record) => {
    let requestParam = {
        url: `/admin/v1/news/${record.id}`,
        method: 'delete'
    }
    baseService(requestParam).then((res) => {
        message.success('删除成功')
        loadData()
    }).catch((res) => {
        message.error(res.msg || '删除失败')
    })
}

// 弹窗确认
const handleModalOk = async () => {
    try {
        await formRef.value?.validate()
        state.modalLoading = true

        const url = state.modalType === 'add' ? '/admin/v1/news' : `/admin/v1/news/${formData.id}`
        const method = state.modalType === 'add' ? 'post' : 'put'

        let requestParam = {
            url: url,
            method: method,
            data: {
                title: formData.title,
                body: formData.body,
                cat_id: formData.cat_id
            }
        }

        const res = await baseService(requestParam)
        if (res.code === 0 || res.code === 200) {
            message.success(state.modalType === 'add' ? '新增成功' : '编辑成功')
            state.modalVisible = false
            loadData()
        } else {
            message.error(res.msg || '操作失败')
        }
    } catch (error) {
        console.log('表单验证失败:', error)
    } finally {
        state.modalLoading = false
    }
}

// 弹窗取消
const handleModalCancel = () => {
    state.modalVisible = false
    formRef.value?.resetFields()
}

const cancel = () => {
    state.showModel = 'list'
    state.showInfo = false
}
const onOk = () => {
    state.showModel = 'list'
    state.showInfo = false
    loadData()
}

// 重置列表方法
const resetList = () => {
    if (state.showModel === 'info') {
        state.showModel = 'list'
        state.showInfo = false
        state.detailData = {}
        loadData()
    }
}

// 暴露方法给父组件
defineExpose({
    onOk: onOk,
    resetList: resetList,
    backToList: backToList
})

const queryDetail = (id) => {
    let requeryParam = {
        url: `/admin/v1/news/${id}/info`,
        method: 'get'
    }
    baseService(requeryParam).then((res) => { })
}
const handleImageClick = (e) => {
    // 检查点击的是否是图片
    if (e.target.tagName === 'IMG') {
        const img = e.target
        console.log('点击了图片:', img.src)
        console.log('alt属性:', img.alt)
        console.log('自定义数据:', img.dataset.src)

        // 在这里处理图片点击逻辑
        setVisible(true, img.src)
    }
}
//预览
const setVisible = (value, url): void => {
    if (value) {
        state.previewImage = url
        state.previewVisible = true
    } else {
        state.previewVisible = false
    }
}
</script>

<style lang="less" scoped>
.detail-wrapper {
    padding: 20px;
    height: 100%;
    overflow-y: auto;
    background: #f5f7fa;
}

.detail-container {
    max-width: 900px;
    margin: 0 auto;
}

.detail-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 40px 48px 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
    }
}

.detail-back {
    margin-bottom: 20px;

    .back-btn {
        font-size: 14px;
        color: #1677ff;
        padding: 0;

        &:hover {
            color: #4096ff;
        }
    }
}

.detail-title {
    font-size: 28px;
    font-weight: 600;
    color: #1f2f3d;
    text-align: center;
    margin: 0 0 24px 0;
    line-height: 1.4;
    letter-spacing: 0.5px;
}

.detail-meta {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
    color: #8c8c8c;
    font-size: 14px;

    .meta-item {
        display: flex;
        align-items: center;
        color: #666;

        span {
            color: #666;
        }
    }

    .meta-divider {
        width: 1px;
        height: 16px;
        background: #e8e8e8;
    }
}

.detail-divider {
    height: 1px;
    background: linear-gradient(to right, transparent, #e8e8e8 20%, #e8e8e8 80%, transparent);
    margin-bottom: 30px;
}

.detail-body {
    font-size: 16px;
    line-height: 1.8;
    color: #2c3e50;
    min-height: 200px;

    :deep(p) {
        margin-bottom: 16px;
    }

    :deep(img) {
        max-width: 100%;
        height: auto;
        border-radius: 8px;
        margin: 16px 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
            transform: scale(1.01);
        }
    }

    :deep(blockquote) {
        border-left: 4px solid #1677ff;
        padding: 12px 20px;
        margin: 16px 0;
        background: #f6f8fa;
        border-radius: 4px;
        color: #555;
    }

    :deep(code) {
        background: #f6f8fa;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 14px;
        color: #d63384;
    }

    :deep(pre) {
        background: #1e1e1e;
        color: #d4d4d4;
        padding: 16px 20px;
        border-radius: 8px;
        overflow-x: auto;
        margin: 16px 0;

        code {
            background: transparent;
            color: #d4d4d4;
            padding: 0;
        }
    }

    :deep(ul),
    :deep(ol) {
        padding-left: 24px;
        margin-bottom: 16px;
    }

    :deep(li) {
        margin-bottom: 6px;
    }

    :deep(a) {
        color: #1677ff;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    :deep(table) {
        width: 100%;
        border-collapse: collapse;
        margin: 16px 0;

        th,
        td {
            border: 1px solid #e8e8e8;
            padding: 10px 14px;
            text-align: left;
        }

        th {
            background: #f6f8fa;
            font-weight: 600;
        }
    }
}

.detail-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;

    .footer-left {
        display: flex;
        gap: 8px;
        align-items: center;
    }

    .footer-right {
        .footer-time {
            font-size: 13px;
            color: #bfbfbf;
        }
    }
}

// 响应式
@media (max-width: 768px) {
    .detail-wrapper {
        padding: 12px;
    }

    .detail-card {
        padding: 24px 20px 20px;
    }

    .detail-title {
        font-size: 22px;
    }

    .detail-meta {
        font-size: 13px;
        gap: 8px;

        .meta-divider {
            display: none;
        }
    }

    .detail-body {
        font-size: 15px;
        line-height: 1.7;
    }
}
</style>
